<template>
	<v-text-field
		class="input-searcher pt-0"
		:class="{ 'color-white' : colorWhite, 'color-newprimary' : colorNewPrimary }"
		v-bind="$attrs"
		hide-details
		@input="onSearch"
	></v-text-field>
</template>

<script>
	function onSearch(value) {
		this.$emit('on-search', { model: this.model, value });
	}

	export default {
		name: 'input-searcher',
		inheritAttrs: false,
		methods: {
			onSearch,
		},
		props: {
			colorNewPrimary: {
				default: false,
				type: Boolean,
			},
			colorWhite: {
				default: false,
				type: Boolean,
			},
			model: String,
		},
	};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/input-searcher.vue